module.exports = __webpack_public_path__ + "static/media/Hero_Image_Desktop_9.c4080509.jpg";